<template>
	<div :class="modal ? 'modal is-active' : 'modal'">
		<div class="modal-background"></div>
		<div class="modal-card is-small">
			<header class="modal-card-head">
				<button @click="closeModal" class="delete" aria-label="close"></button>
				<p class="modal-card-title">Order Receipt</p>
			</header>
			<section class="modal-card-body" v-if="modal">

				<div class="order-details is-shadowless">
					<div class="order-info is-flex justify-content-between">
						<div class="order-id">Order <span class="id">#{{orderDetail.id}}</span></div>
						<div class="order-timestamp">
							<span class="order-time">{{orderTime(orderDetail)}}, </span>
							<span class="order-date">{{orderDate(orderDetail)}}</span>
						</div>
					</div>
					<div class="order-store is-flex bg-transparent mb0">
					  <img v-if="orderDetail.location.images && getStorefeaturedImage(orderDetail.location.images)" :src="getStorefeaturedImage(orderDetail.location.images)" alt class="order-history-img is-block mr20" />
            <img v-else src="@/assets/img/icon-marker-green.svg" alt class="is-block mr20" />

						<div class="store-detail">
							<div class="store-name has-text-weight-semibold is-uppercase">
								<p class="text-dark">{{orderDetail.location.display_name}}</p>
							</div>
							<div class="store-address">
							  <p v-if="orderDetail.location.address">{{orderDetail.location.address.formatted_address}}</p> 
							</div>
						</div>
					</div>

					<div class="order-item" v-for="(order, index) in orderDetail.order_items" :key="'product'+index">
						<div class="order-item-left order-receipt-modal-sn-wrap">
							<div class="order-srno order-receipt-modal-sn">{{ index + 1 }}</div>
							<div class="order-product-name">{{order.product_name}} X {{order.unit}}</div>
						</div>
						<div class="order-item-right">
							<div class="order-weight">{{ order.weight ? order.weight.toFixed(2) : '0.00'}}{{ order.weighting_unit ? order.weighting_unit : '' }}</div>
							<div class="order-price order-record-price">$ {{order.price.toFixed(2)}}</div>
						</div>
					</div>

          <div class="order-subtotal is-flex justify-content-between is-borderless pt20 pb0" v-if="orderDetail.order_loyalty && (orderDetail.order_loyalty.length > 0) && (orderDetail.order_loyalty[0].points_earned > 0)">
						<span>Points Earned: {{ new Intl.NumberFormat().format(orderDetail.order_loyalty[0].points_earned) }}</span>            
          </div>

					<div class="order-subtotal is-flex justify-content-between is-borderless pt20 pb0">
						<span>Subtotal</span> 
            <span class="subtotal-price">$ {{ subtotal }}</span>
          </div>

          <div class="order-subtotal is-flex justify-content-between is-borderless pt20 pb0" v-if="orderDetail.deposit">
						<span>Deposit</span> 
            <span class="subtotal-price">$ {{ orderDetail.deposit.toFixed(2) }}</span>
          </div>

          <div class="order-subtotal is-flex justify-content-between is-borderless pb0" v-if="promoCodeDiscount">
						<span>Promo Code: {{ orderDetail.order_promocodes[0].code}}</span> 
            <span class="subtotal-price"> - $ {{ promoCodeDiscount }}</span>
          </div>

          <div class="order-subtotal is-flex justify-content-between is-borderless pb0" v-if="loyaltyDiscount">
						<span>Points Used: {{ new Intl.NumberFormat().format(orderDetail.order_loyalty[0].points_redeemed) }}</span> 
            <span class="subtotal-price"> - $ {{ loyaltyDiscount }}</span>
          </div>

					<div class="order-tax is-flex justify-content-between pb0">
            <span>Tax</span> 
            <span class="tax-price text-dark">$ {{ orderDetail.tax? orderDetail.tax.toFixed(2) : '0.00' }}</span>
          </div>
          <div v-if="orderDetail.order_receive_method == 'delivery'" class="order-tax is-flex justify-content-between pv0"><span>Delivery fee</span> <span
							class="tax-price text-dark">$ {{ orderDetail.delivery_fee.toFixed(2) }}</span></div>

           <div v-if="orderDetail.order_receive_method == 'delivery'" class="order-tax is-flex justify-content-between pv0">
              <span>Tip</span> 
              <span class="tax-price text-dark">$ {{ orderDetail.tip ? orderDetail.tip.toFixed(2)  : '0.00' }}</span>
            </div>

					<div class="order-total is-flex justify-content-between is-size-15"><span>Total</span> <span
							class="total-price">$ {{ orderDetail.total.toFixed(2) }}</span>
					</div>
				</div>
			</section>
			<footer class="modal-card-foot">
				<button @click="emailReceipt(orderDetail.id)" class="button is-large is-transparent is-full-width">Email Receipt</button>
			</footer>
		</div>
	</div>
</template>

<script>
import Helpers from '@/Components/Helpers/Helpers';
import { format } from "date-fns";
import Env from "@/env";
import { mapActions } from "vuex";
import moment from 'moment';
import 'moment-timezone';

export default {
  data() {
    return {
      modal: false,
      orderDetail: '',
    };
  },

  mounted() {
    bus.$on('show-modal-order-recepit', (payload) => {
      this.modal = payload.modal;
      this.orderDetail = payload.order;
    })
  },

  computed: {
    promoCodeDiscount() {
      if( this.orderDetail.order_promocodes && (this.orderDetail.order_promocodes.length > 0) ){
       return this.orderDetail.order_promocodes[0].code ? this.orderDetail.order_promocodes[0].applied_value.toFixed(2) : 0;
      }
      return 0;
    },

    loyaltyDiscount() {
      if( this.orderDetail.order_loyalty && (this.orderDetail.order_loyalty.length > 0) && (this.orderDetail.order_loyalty[0].reward_amount > 0) ){
       return this.orderDetail.order_loyalty[0].reward_amount.toFixed(2);
      }
      return 0;
    },

    subtotal () {
      return this.orderDetail.sub_total ? this.orderDetail.sub_total.toFixed(2) : '0.00';
    },
  },

  beforeDestroy() {
    bus.$off('show-modal-order-recepit');
  },

  methods: {
     /**
     * Get store featured image
     */
    getStorefeaturedImage(images) {
      return Helpers.getStoreFeaturedImage(images);
    },

    closeModal() {
      this.modal = false;
    },

     // get order time and date
    orderTime(order) {
      if (_.isEmpty(order)) return '';
      return moment.utc(order.created_at).tz(order.location.address && order.location.address.timezone_id ? order.location.address.timezone_id : 'America/Toronto').format('h:mm a');
    },

    // get order date
    orderDate(order) {
      if (_.isEmpty(order)) return '';
      return moment.utc(order.created_at).tz(order.location.address && order.location.address.timezone_id ? order.location.address.timezone_id : 'America/Toronto').format('MMM DD YYYY');
    },
    /**
     * Sign out
     */
    emailReceipt(orderId) {
      this.va_spinner(true);
      const url = `${Env.orderUrl}/api/v1/orders/${orderId}/sendEmailReceipt`;
      this.getApi(url, {
        "app-id": Env.productAppId,
        "app-secret": Env.productAppSecret
      })
      .then(res => {
        this.va_spinner(false);
        this.va_snackbar({
          message: res.data.msg ? res.data.msg : 'Email receipt sent successfully.',
          type: 'success',
        });
      }).catch((err) => {
        this.va_spinner(false);
         this.va_snackbar({
          message: Helpers.catchErrorMessage(err.response.data),
          type: 'warning',
        });
      })
    },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar"
    })
    
  },
};
</script>

<style scoped>
.order-history-img {
  object-fit: contain;
}
.order-item-left.order-receipt-modal-sn-wrap {
    padding-left: 36px;
    position: relative;
}
.order-srno.order-receipt-modal-sn {
    position: absolute;
    left: 0;
    top: 0;
}
</style>